export default "__VITE_ASSET__BM6V9lcT__"